import Author from "components/author";
import MDBadge from "components/MDBadge";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { AccountStatuses } from "../../layouts/accounts/data/accountsTableData";
import Modal from "../../components/modal";

export default function NotEnteredAccounts({ open, setOpen, accounts }) {
  return (
    <Modal
      open={open}
      title={"missing records"}
      actions={
        <MDBox display="flex" gap={1} justifyContent="right">
          <MDButton
            onClick={() => {
              setOpen(false);
            }}
            variant="gradient"
            color="error"
          >
            close
          </MDButton>
        </MDBox>
      }
    >
      <MDBox>
        {accounts.map((account, index) => (
          <MDBox
            key={index}
            display="flex"
            style={{
              alignItems: "baseline",
              marginBottom: 5,
              paddingBottom: 5,
              borderBottom: "1px solid #d2d2d2",
            }}
          >
            <MDTypography
              width={60}
              display="block"
              variant="caption"
              color="text"
              fontWeight="medium"
            >
              {account.account_number}
            </MDTypography>
            <Author name={account.holder_name} address={account.address} />
            {account.status != AccountStatuses.ACTIVE && (
              <MDBadge
                badgeContent={account.status}
                color={account.status === AccountStatuses.SUSPENDED ? "error" : "warning"}
                variant="gradient"
                size="sm"
              />
            )}
          </MDBox>
        ))}
      </MDBox>
    </Modal>
  );
}
